module.exports = __webpack_public_path__ + "img/HARDWARE_DT.40e52270.png";